import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { listNftByStatus } from "services/apiService";
import { listNftStatic } from "services/apiService";
import { postLike } from "services/apiService";
import { getFeed } from "services/apiService";

export const fetchListNftStatic = createAsyncThunk(
  "fetchListNftStaticRes",
  async (number) => {
    try {
      const listNftStaticRes = await listNftStatic(number);
      // console.log("here1", getFeedRes);
      return listNftStaticRes;
    } catch (error) {
      console.log("fetchListNftStaticReducerError", error);
    }
  }
);

export const fetchListNftByStatus = createAsyncThunk(
  "fetchListNftByStatus",
  //createAsyncThunk byDefault allows only one parameter so passing 1 object and destructuring
  async ({ number, status }) => {
    try {
      const listNftByStatusRes = await listNftByStatus(number, status);

      return listNftByStatusRes.data;
    } catch (error) {
      console.log("fetchListNftByStatusError", error);
    }
  }
);

const initialState = {
  nftListStatic: {
    forSaleNftList: [],
    forBiddingNftList: [],
    liveAuctionNftList: [],
    singhNftList: [],
  },
  isLoadingStatic: false,
  nftListByStatus: {
    listNft: [],
    count: 0,
    pageNumber: 0,
  },
  isLoadingNftByStatus: false,
};

const nftSlice = createSlice({
  name: "Nfts",
  initialState: initialState,
  reducers: {
    nftListByStatusReducerPlus(state, action) {
      state.nftListByStatus.listNft.push(...action.payload);
      state.nftListByStatus.pageNumber += 1;
    },
    nftReducerReset() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchListNftStatic.pending, (state) => {
        state.isLoadingStatic = true;
      })
      .addCase(fetchListNftStatic.fulfilled, (state, action) => {
        state.nftListStatic.forSaleNftList = action.payload[0].data;
        state.nftListStatic.forBiddingNftList = action.payload[1].data;
        state.nftListStatic.liveAuctionNftList = action.payload[2].data;
        state.nftListStatic.singhNftList = action.payload[3].data;
        state.isLoadingStatic = false;
      })
      .addCase(fetchListNftByStatus.pending, (state) => {
        state.isLoadingNftByStatus = true;
      })
      .addCase(fetchListNftByStatus.fulfilled, (state, action) => {
        state.nftListByStatus.listNft = action.payload;
        state.nftListByStatus.count = action.payload[0]?.countNFT;
        state.isLoadingNftByStatus = false;
      });
  },
});

export const { nftListByStatusReducerPlus, nftReducerReset } = nftSlice.actions;
export default nftSlice.reducer;

// const likeReducer = (state, action) => {
//   const updatedPost = action.payload;

//   // Create a new array by looping through the feed array
//   const updatedFeed = state.feed.map((post) => {
//     // If the post id matches with the updated post id, return the updated post
//     if (post._id === updatedPost._id) {
//       return updatedPost;
//     }
//     // Otherwise, return the original post
//     return post;
//   });

//   // Update the state with the updated feed array
//   state.feed = updatedFeed;
// };
